import { createClient } from '@supabase/supabase-js'
import { createClientComponentClient } from '@supabase/auth-helpers-nextjs'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || ''
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || ''

// Cliente para uso em componentes do servidor
export const supabase = createClient(supabaseUrl, supabaseKey)

// Cliente para uso em componentes do cliente
export const createBrowserClient = () => {
  return createClientComponentClient()
} 